























import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import type { PublicPortfolioUser } from '@/types/graphql';

@Component<UniversalSearchResultsPortfolio>({
  components: {
    UniversalSearchResultsItem,
    Avatar,
  },
})
export default class UniversalSearchResultsPortfolio extends Vue {
  @Prop({ default: false }) removable!: boolean;
  @Prop({ required: true }) item!: { portfolioUser: PublicPortfolioUser };

  get name() {
    return [this.item.portfolioUser.firstname, this.item.portfolioUser.lastname].filter(Boolean).join(' ');
  }

  get description() {
    const company = this.item.portfolioUser.currentCompany?.name;
    const position = this.item.portfolioUser.currentPosition;
    if (!position || !company) return position || company;
    return `${position} at ${company}`;
  }
}
